var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs2, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _g, _path78, _g2, _path79, _g3, _path80, _g4, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _g5, _g6, _path88, _path89, _path90, _path91, _path92, _path93, _g7, _path94, _path95, _path96, _g8, _g9, _g10, _g11, _path97, _path98, _path99, _g12, _g13, _g14, _g15, _path100, _path101, _path102, _path103;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGirlRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 839 774",
    style: {
      enableBackground: "new 0 0 839 774"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#F2F2F2;}\r\n\t.st2{fill:#3F3D56;}\r\n\t.st3{fill:#112869;}\r\n\t.st4{opacity:0.1;enable-background:new    ;}\r\n\t.st5{opacity:0.15;enable-background:new    ;}\r\n\t.st6{fill:url(#SVGID_3_);}\r\n\t.st7{fill:#2F2E41;}\r\n\t.st8{fill:#FBBEBE;}\r\n\t.st9{clip-path:url(#SVGID_5_);}\r\n\t.st10{opacity:0.7;}\r\n\t.st11{opacity:0.7;fill:url(#SVGID_6_);enable-background:new    ;}\r\n\t.st12{opacity:0.2;enable-background:new    ;}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{opacity:0.7;fill:url(#SVGID_7_);enable-background:new    ;}\r\n\t.st15{opacity:0.7;fill:url(#SVGID_8_);enable-background:new    ;}\r\n\t.st16{fill:#535461;}\r\n\t.st17{opacity:0.1;}\r\n\t.st18{fill:#E0E0E0;}\r\n\t.st19{fill:url(#SVGID_9_);}\r\n\t.st20{fill:url(#SVGID_10_);}\r\n\t.st21{fill:url(#SVGID_11_);}\r\n\t.st22{fill:url(#SVGID_12_);}\r\n\t.st23{fill:#EEEEEE;}\r\n\t.st24{fill:url(#SVGID_13_);}\r\n\t.st25{fill:url(#SVGID_14_);}\r\n\t.st26{fill:url(#SVGID_15_);}\r\n\t.st27{fill:url(#SVGID_16_);}\r\n\t.st28{fill:url(#SVGID_17_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 324,
    width: 839,
    height: 450
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.1,566.6v174.8h-26.8l-72.7-120.3L200.1,566.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100,658c42.8,28.4,54.8,78.2,54.8,78.2s-57.3,3.8-100-24.5C12.1,683.3,0,633.5,0,633.5S57.3,629.6,100,658z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M154.8,735.7c0,0,0.6-0.3,1.8-0.9c0.9-0.5,2.1-1.2,3.7-2.1c13.4-7.9,48.3-31,62.5-66.7 c17.9-44.7-3.2-92.1-3.2-92.1s-46,23-65.6,64.2c-0.9,1.8-1.6,3.6-2.4,5.4c-15.5,38.9-1.6,79.8,2.3,89.8 C154.5,734.9,154.8,735.7,154.8,735.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.6,737.2l0.7-0.4c0.5-0.3,46.9-30.6,58.8-76.5c11.9-45.9-14.9-91.2-15.1-91.6l-0.4-0.6l-0.7,0.4 c-0.5,0.3-46.9,30.6-58.8,76.5c-11.9,45.9,14.9,91.2,15.1,91.6L154.6,737.2z M198.1,569.9c3.2,5.7,25.6,47.7,14.6,90.1 c-11,42.4-51.9,71.4-57.6,75.3c-3.2-5.7-25.6-47.7-14.6-90.1C151.5,602.8,192.4,573.8,198.1,569.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M153.9,733.5c1,0.5,2,1,2.7,1.4c1.6,0.8,2.6,1.2,2.6,1.2s0.4-1.2,1.1-3.3c3.6-11.6,14-51.8-3.4-88.9 c-0.9-1.9-1.9-3.8-2.9-5.7c-0.9,1.8-1.6,3.6-2.4,5.4C136.1,682.5,150,723.5,153.9,733.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.2,671.3c20.5,43.8,72,66.4,72,66.4s18.2-48.4-2.3-92.1c-20.5-43.8-72-66.4-72-66.4S61.7,627.5,82.2,671.3 z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81,580.8l73.4,155.3l-1.3,0.5L79.7,581.3L81,580.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.8,750.5c0,5.9,38,11.2,100.9,15.4c11.4,0.7,23.7,1.5,36.7,2.1c11.2,0.6,23,1.1,35.3,1.6 c11.9,0.5,24.3,0.9,37.1,1.3c40.5,1.3,85.4,2.3,133,2.7c11.6,0.1,23.3,0.2,35.1,0.3c12.4,0.1,24.9,0.1,37.5,0.1 c229.5,0,415.6-10.5,415.6-23.5S652.9,727,423.4,727c-98.8,0-189.6,2-260.9,5.2c-2.6,0.1-5.2,0.2-7.8,0.4c0,0,0,0-0.1,0 C64.8,736.9,7.8,743.3,7.8,750.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7.8,750.5c0,5.9,38,11.2,100.9,15.4c11.4,0.7,23.7,1.5,36.7,2.1c11.2,0.6,23,1.1,35.3,1.6 c11.9,0.5,24.3,0.9,37.1,1.3c40.5,1.3,85.4,2.3,133,2.7c11.6,0.1,23.3,0.2,35.1,0.3c12.4,0.1,24.9,0.1,37.5,0.1 c229.5,0,415.6-10.5,415.6-23.5S652.9,727,423.4,727c-98.8,0-189.6,2-260.9,5.2c-2.6,0.1-5.2,0.2-7.8,0.4c0,0,0,0-0.1,0 C64.8,736.9,7.8,743.3,7.8,750.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.7,746.4c0,4.9,35.5,9.4,94.1,12.8c10.7,0.6,22.1,1.2,34.2,1.8c10.5,0.5,21.4,0.9,32.9,1.3 c11.1,0.4,22.7,0.8,34.6,1.1c37.8,1.1,79.6,1.9,124,2.3c10.8,0.1,21.7,0.2,32.7,0.2c11.5,0.1,23.2,0.1,34.9,0.1 c214,0,387.5-8.8,387.5-19.7c0-10.9-173.5-19.7-387.5-19.7c-47.3,0-92.7,0.4-134.6,1.2h-0.1c-39.6,0.7-76.2,1.8-108.5,3.1 c-2.4,0.1-4.9,0.2-7.3,0.3c0,0,0,0,0,0c-14.8,0.6-28.7,1.3-41.4,2.1c-0.1,0-0.3,0-0.4,0C75.6,736.9,39.7,741.4,39.7,746.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.2,733.4c5.2,30.3,38.3,20.1,78.3,20.1c42.3,0,76.8,11.3,78.9-25.6c-39.6,0.7-76.2,1.8-108.5,3.1 c-2.4,0.1-4.9,0.2-7.3,0.3c0,0,0,0,0,0C161.8,732,148,732.7,135.2,733.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M615,724.2c0,10.9,7.3,14.7,16.3,14.7c0.2,0,0.4,0,0.6,0c0.4,0,0.8,0,1.2,0c8.1-0.5,14.5-4.5,14.5-14.7 c0-10.5-15.1-23.8-16.3-24.7l0,0c0,0-0.1-0.1-0.1-0.1S615,713.3,615,724.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M632,737.3l-6-7.4l6,8.2l0,0.8c0.4,0,0.8,0,1.2,0l-0.6-10.9l0-0.1l0,0l-0.1-1l6-8.2l-6,7.5l0,0.2L632,718 l5.1-8.5l-5.2,7.1l-0.5-17.1l0-0.1v0.1l0.1,13.5l-5.1-5.3l5.1,6.5l0.1,7.4l-4.8-7.1l4.8,8.2l0.1,4.1l-6.9-9.9l7,11.3L632,737.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.6,716.6c0-41.5-35.4-75.2-79.1-75.2s-79.1,33.7-79.1,75.2c0,41.5,35.4,29.5,79.1,29.5 S292.6,758.1,292.6,716.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M730.7,667h1.4v84.7h-1.4V667z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M731.4,679c-7.5,0-13.5-5.4-13.5-12c0-6.6,6-12,13.5-12c7.5,0,13.5,5.4,13.5,12 C744.9,673.7,738.9,679,731.4,679z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M731.4,719.3c0,0,1.9-36.8,41.4-32.5L731.4,719.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.0255,
    y1: 91.729,
    x2: 389.0255,
    y2: 124.045,
    gradientTransform: "matrix(1 0 0 -1 0 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M338.5,681c-0.4,1.1-0.7,2.2-1.2,3.3c1.9-1.6,3.7-3.3,5.6-5c-0.8,0.2-1.5,0.4-2.2,0.7 C340,680.2,339.2,680.6,338.5,681z M347.6,675.5c11.1-8.6,24-15.2,35.4-23.5c-6.2,2.7-12.3,5.9-18.3,8.9 c-7.1,3.6-14.3,7.1-21.6,10.4C344.3,672.9,345.8,674.3,347.6,675.5z M342.9,653.9c-0.2-0.2-0.4-0.3-0.5-0.5c0,1.2,0,2.4,0,3.4 c1-0.3,2-0.6,3-0.9C344.4,655.3,343.6,654.6,342.9,653.9z M440.7,677.1c-4.6-4.6-8.6-9.6-11.9-15c-4.4,6.8-11.6,11.8-17.7,17.5 C421,678.4,430.9,677.5,440.7,677.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M756.2,740.5c0,10.9,7.3,14.7,16.3,14.7c0.2,0,0.4,0,0.6,0c0.4,0,0.8,0,1.2-0.1c8.1-0.5,14.5-4.5,14.5-14.7 c0-10.5-15.1-23.8-16.3-24.7l0,0c0,0-0.1-0.1-0.1-0.1S756.2,729.6,756.2,740.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M773.1,753.6l-6-7.4l6,8.2l0,0.9c0.4,0,0.8,0,1.2-0.1l-0.6-10.9l0-0.1l0,0l-0.1-1l6-8.2l-6,7.5l0,0.2 l-0.5-8.3l5.1-8.5l-5.2,7.1l-0.5-17.1l0-0.1v0.1l0.1,13.5l-5.1-5.3l5.1,6.5l0.1,7.4l-4.8-7.1l4.8,8.2l0.1,4.1l-6.9-9.9l7,11.3 L773.1,753.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M747.9,653.7c-3.9,0-7.1-2.8-7.1-6.3c0-3.5,3.2-6.3,7.1-6.3c3.9,0,7.1,2.8,7.1,6.3 C755,650.9,751.8,653.7,747.9,653.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294,559.7c0,0-25.6-5-28.4,15c-2.8,20.1,13.6,23.8,13.6,23.8l10.4,2.5l40.2-9.4l-5.6-14.4L294,559.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.3,560.8c-19.1,0-34.6-13.8-34.6-30.7c0-17,15.5-30.7,34.6-30.7c19.1,0,34.6,13.8,34.6,30.7 C337.9,547,322.4,560.8,303.3,560.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M424.9,593.9l-7,1.3l-23.9,31.4l10.5,1.3L424.9,593.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M595,721.2c-1.9,5.5-4.2,11-7,16.2c-7.9-1.5-15.7-3.4-23.3-5.9c-0.2-0.1,4.4-5.4,4.8-5.9 c1.8-1.6,4.2-3.6,6.6-4.5c2.4-0.9,5.4-0.2,8-0.1C587.7,721.2,591.3,721.3,595,721.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M576,729.6c4-1.1,6.4-4.6,8-8.1c1.6-3.4,2.9-7.1,6-9.6c1.2,0,2.1,0.9,2.7,1.8s0.9,1.9,1.6,2.8 c1.3,1.6,3.5,2.4,5.1,3.8c1.7,1.5,2.6,3.5,4.3,4.9c2.2,1.8,5.3,2.2,8.1,2.8c4.4,0.9,8.7,2.3,12.7,4.2c1.5,0.8,3.1,1.4,4.7,1.9 c1.8,0.3,3.7,0.4,5.5,0.2l12.7-0.8c1.1-0.1,2.3-0.1,3.4,0.1c2.6,0.6,4.2,3.2,4,5.6c-0.2,2.4-1.9,4.6-4,6.1 c-2.2,1.4-4.6,2.5-7.2,3.2c-11,3.7-22.4,6.6-34,8.6l0,2.2c-8.1,3.5-16.9,5.3-25.9,5.3c-0.7,0-1.3-0.1-1.9-0.3 c-0.9-0.4-1.3-1.4-1.6-2.2c-3-7.9-4.8-16.1-5.3-24.5c-0.2-2.1,0-4.2,0.5-6.3c0.7-2-1.7-1.2,0.5-2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M332.9,687.2c37.6,2,74.7-7.8,112.4-8.8c4.7-0.1,9.4-0.1,14,0.8c4.8,1,9.3,2.9,13.8,4.8 c20.2,8.3,41.1,15.2,61.9,22.1l24,7.9c4.8,1.6,9.7,3.2,14.8,2.9c2.3-0.1,5.1-0.4,6.4,1.3c3.9,5.1,2.1,12.7-0.5,18.4 c-0.8,1.9-2.2,3.9-4.5,4.1c-1.6,0.2-3-0.7-4.6-1c-4.4-1-8.7,1.6-13.2,2c-5.5,0.5-10.7-2.3-15.9-4c-8.7-2.8-18.2-2.8-27.3-4.1 c-15.3-2.3-29.5-8.6-42.7-15.8c-5-2.7-10.2-5.7-16-6.7c-6.7-1.2-13.5,0.4-20,2c-15.6,3.9-30.9,8.6-46,13.9 c-7.9,2.8-15.8,5.8-24,7.8c-17.8,4.2-36.7,3.2-53.8-2.8c-6-2.1-12.6-5.8-12.9-11.6c-0.2-3.3,2.7-6.2,4.6-9 c1.2-1.8,2.5-3.6,3.8-5.3C313.6,697.6,321.5,686.5,332.9,687.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.9,687.2c37.6,2,74.7-7.8,112.4-8.8c4.7-0.1,9.4-0.1,14,0.8c4.8,1,9.3,2.9,13.8,4.8 c20.2,8.3,41.1,15.2,61.9,22.1l24,7.9c4.8,1.6,9.7,3.2,14.8,2.9c2.3-0.1,5.1-0.4,6.4,1.3c3.9,5.1,2.1,12.7-0.5,18.4 c-0.8,1.9-2.2,3.9-4.5,4.1c-1.6,0.2-3-0.7-4.6-1c-4.4-1-8.7,1.6-13.2,2c-5.5,0.5-10.7-2.3-15.9-4c-8.7-2.8-18.2-2.8-27.3-4.1 c-15.3-2.3-29.5-8.6-42.7-15.8c-5-2.7-10.2-5.7-16-6.7c-6.7-1.2-13.5,0.4-20,2c-15.6,3.9-30.9,8.6-46,13.9 c-7.9,2.8-15.8,5.8-24,7.8c-17.8,4.2-36.7,3.2-53.8-2.8c-6-2.1-12.6-5.8-12.9-11.6c-0.2-3.3,2.7-6.2,4.6-9 c1.2-1.8,2.5-3.6,3.8-5.3C313.6,697.6,321.5,686.5,332.9,687.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M522.8,722.8c-5.9,1.8-11.8,3.4-17.8,4.9c-3.4-4.9-9.6-8.3-11-13.9c-0.1-0.2-0.1-0.5,0-0.7 c0.2-0.2,0.4-0.4,0.7-0.5c4.3-2.1,9-3.3,13.9-3.6c3.9-0.2,5.6,3.4,7.4,5.9C516.6,715.9,521.2,723.3,522.8,722.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M514.5,719.3c3.5-0.6,6.9-2.3,8.6-5c0.8-1.3,1.7-3,3.4-2.9c1.5,0.1,2.2,1.7,2.6,3.1c1.3,5,2.6,10.1,4.9,14.8 c2.3,4.7,5.6,9.2,10.4,12.1c2.2,1.3,4.6,2.4,6.7,3.8c1.9,1.3,3.6,2.9,5.7,3.8c1.4,0.6,2.9,1.1,4.4,1.4c2.2,0.7,4.3,1.6,6.3,2.7 c1.7,0.9,3.2,2.1,4.3,3.6c0.5,0.8,0.8,1.6,0.9,2.5c0.1,0.9-0.1,1.8-0.6,2.6c-0.5,0.7-1.1,1.2-1.8,1.7s-1.5,0.7-2.4,0.9 c-1.7,0.3-3.5,0.3-5.2,0.1c-6.9-0.4-13.7-1-20.5-1.5c-2.9-0.2-5.8-0.5-8.6-1.1c-1.5-0.3-3-0.7-4.5-1.1c-2.6-0.6-5.2-0.9-7.8-1 c-0.8-0.1-1.5,0-2.3,0.2c-1.6,0.5-2.7,1.9-4.3,2.1c-1.1,0.1-2.1,0-3.1-0.4c-4.9-1.2-10.1-1.2-15.2-1.4c-2.2-0.1-4.9-0.5-5.9-2.3 c-1.3-2.2,0.8-4.7,1.7-7.1c0.4-1.5,0.7-3.1,0.7-4.7c0.4-3.9,1.7-7.7,3.8-11.1c1.7-2.8,4.1-6,2.9-9c-0.4-1-1.2-2-1.2-3.1 C498.7,718.2,511.4,719.8,514.5,719.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M389.3,633.6c6.7-2.6,12-7.3,15-13.2c0.6-1.3,1.1-2.6,1.7-3.9c2-4.2,5-8,8.9-11c1-0.7,2.1-1.4,3.3-1.2 c1.1,0.2,2.1,1.2,2.4,2.3c0.3,1.2,0.4,2.4,0.2,3.6c-0.3,2.8-0.9,5.6-1.6,8.3l-1.8,7.4c-0.2,1.1-0.6,2.2-1.1,3.3 c-0.8,1.2-1.8,2.3-3.1,3.2c-1.7,1.4-3.4,2.7-5.1,4c-2.4,2-5.5,3.3-8.8,3.5c-7.5,1.2-15.1,3-21.4,7.3c0.1,0,0-4.9,0.1-5.5 c0.3-1.5,0.5-3,1.6-4C382.3,635.5,386.3,634.8,389.3,633.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M389.3,633.6c6.7-2.6,12-7.3,15-13.2c0.6-1.3,1.1-2.6,1.7-3.9c2-4.2,5-8,8.9-11c1-0.7,2.1-1.4,3.3-1.2 c1.1,0.2,2.1,1.2,2.4,2.3c0.3,1.2,0.4,2.4,0.2,3.6c-0.3,2.8-0.9,5.6-1.6,8.3l-1.8,7.4c-0.2,1.1-0.6,2.2-1.1,3.3 c-0.8,1.2-1.8,2.3-3.1,3.2c-1.7,1.4-3.4,2.7-5.1,4c-2.4,2-5.5,3.3-8.8,3.5c-7.5,1.2-15.1,3-21.4,7.3c0.1,0,0-4.9,0.1-5.5 c0.3-1.5,0.5-3,1.6-4C382.3,635.5,386.3,634.8,389.3,633.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M312.7,577.2c-5,0-9.1-3.7-9.1-8.2c0-4.5,4.1-8.2,9.1-8.2s9.1,3.7,9.1,8.2 C321.9,573.6,317.8,577.2,312.7,577.2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M318.4,564.1c2.5-0.2,5.2-0.4,7.2,0.9c1.1,0.8,1.9,1.8,2.5,3c1.9,3.2,3.8,6.4,4.8,9.9c0.8,3,1,6.1,2,9 c1.9,5.4,6.7,10,7.2,15.7c0.2,2.5-0.2,5.5,1.9,7.2c0.5,0.4,1.1,0.7,1.6,1c1.4,0.9,2.7,2,3.6,3.3c0.8,1.1,1.4,2.4,2.6,3.1 c1.9,1.2,4.9,1.1,5.9,3c0.9,1.9-1.4,4.1-0.9,6.2c0.5,1.7,2.6,2.4,4,3.6c1.9,1.5,2.7,3.7,3.5,5.8c3.1,0.5,6.2,0.4,9.2-0.2 c3-0.7,5.8-1.9,8.3-3.6c-2.6,5.6-2.6,11.7-2.7,17.8c0,2,0,4.1,1.6,5.5c-7.3,0.1-14.4,1.9-21.5,3.3c-3.1,0.6-6.5,1.2-9.4,0 c-1.6-0.8-3.1-1.8-4.3-3c-3.9-3.5-7.9-7.3-8.9-12.1c-0.5-2.7,0-5.5-0.2-8.2c-0.2-3.4-1.3-6.7-2.3-10c-2-6.7-3.4-13.6-4.1-20.5 c-0.4-4.3-4.6-7.7-6.8-11.5c-4.1-7.2-8.4-14.7-8.7-22.8C314.4,567.7,315.4,564.4,318.4,564.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M318.4,564.1c2.5-0.2,5.2-0.4,7.2,0.9c1.1,0.8,1.9,1.8,2.5,3c1.9,3.2,3.8,6.4,4.8,9.9c0.8,3,1,6.1,2,9 c1.9,5.4,6.7,10,7.2,15.7c0.2,2.5-0.2,5.5,1.9,7.2c0.5,0.4,1.1,0.7,1.6,1c1.4,0.9,2.7,2,3.6,3.3c0.8,1.1,1.4,2.4,2.6,3.1 c1.9,1.2,4.9,1.1,5.9,3c0.9,1.9-1.4,4.1-0.9,6.2c0.5,1.7,2.6,2.4,4,3.6c1.9,1.5,2.7,3.7,3.5,5.8c3.1,0.5,6.2,0.4,9.2-0.2 c3-0.7,5.8-1.9,8.3-3.6c-2.6,5.6-2.6,11.7-2.7,17.8c0,2,0,4.1,1.6,5.5c-7.3,0.1-14.4,1.9-21.5,3.3c-3.1,0.6-6.5,1.2-9.4,0 c-1.6-0.8-3.1-1.8-4.3-3c-3.9-3.5-7.9-7.3-8.9-12.1c-0.5-2.7,0-5.5-0.2-8.2c-0.2-3.4-1.3-6.7-2.3-10c-2-6.7-3.4-13.6-4.1-20.5 c-0.4-4.3-4.6-7.7-6.8-11.5c-4.1-7.2-8.4-14.7-8.7-22.8C314.4,567.7,315.4,564.4,318.4,564.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M326.9,694.2c7.8-3.3,13.6-9.5,19.9-14.7c12.1-10.1,26.9-17.2,39.6-26.6c8.4-6.3,16-13.5,25.2-18.8 c8.1-4.6,17.4-7.5,27-8.4c1.1-0.2,2.2-0.1,3.3,0.1c1.2,0.5,2.3,1.2,3.1,2.2c4.1,4.1,7.7,8.6,10.9,13.3 c16.1,24.3,39,44.7,57.9,67.2c0.6,0.5,1,1.2,1,2c0,0.8-0.2,1.5-0.8,2.1l-3.9,6.7c-2.2,3.8-5.6,8.1-10.3,7.4 c-2.1-0.3-3.8-1.7-5.4-3.1l-17.3-14.7L459,693.4c-10.6-9-21.4-18.3-28.4-29.8c-5.4,8.3-15,13.8-21.6,21.4 c-2.5,2.9-4.6,6.1-6.8,9.2c-3.6,4.9-7.7,9.6-11.7,14.2L369.7,732c-2.8,3.2-5.8,6.5-9.6,8.7c-4.9,2.8-10.9,3.5-16.7,4 c-7.8,0.6-15.7,0.9-23.5,0.8c-6-0.1-12.2-0.4-17.5-2.8c-5.4-2.4-9.8-7.2-9.5-12.5c0.1-2.8,1.5-5.4,3-7.8 C303.3,710.1,313,700.1,326.9,694.2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M307.1,581c-3.9,0-7-2.8-7-6.3c0-3.5,3.1-6.3,7-6.3s7,2.8,7,6.3C314.1,578.2,311,581,307.1,581z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M308.7,570c-1.7,2.7-1.7,6-0.8,9c0.9,3,2.7,5.7,4.5,8.3c1.8,2.6,3.5,5.2,5.9,7.4c-10.9,0.5-21.4-3.3-31-7.9 c-7.7-3.7-15.4-8.2-19.5-15.1c2.4,0.6,5.1,0,7.2-1.2c2.1-1.3,3.9-2.8,5.5-4.6l5.4-5.4c1.3-1.2,2.4-2.5,3.4-3.9 c1.2-1.9,1.7-4.1,1.4-6.3c2.2,2,4.6,3.8,7.2,5.3c3.9,2.2,8.2,3.9,12.1,6.1c1.4,0.8,4.5,2.1,3.7,3.7 C312.9,567,309.8,568.3,308.7,570z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308.7,570c-1.7,2.7-1.7,6-0.8,9c0.9,3,2.7,5.7,4.5,8.3c1.8,2.6,3.5,5.2,5.9,7.4c-10.9,0.5-21.4-3.3-31-7.9 c-7.7-3.7-15.4-8.2-19.5-15.1c2.4,0.6,5.1,0,7.2-1.2c2.1-1.3,3.9-2.8,5.5-4.6l5.4-5.4c1.3-1.2,2.4-2.5,3.4-3.9 c1.2-1.9,1.7-4.1,1.4-6.3c2.2,2,4.6,3.8,7.2,5.3c3.9,2.2,8.2,3.9,12.1,6.1c1.4,0.8,4.5,2.1,3.7,3.7 C312.9,567,309.8,568.3,308.7,570z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.5,570.9c2,3,2.5,6.6,0,9.4c-0.3,0.3-1.5,2.5-1.9,2.5c-0.5,0-0.9-0.2-1.2-0.6c-2.6-2.1-4.6-4.9-6.9-7.3 c-2.3-2.4-5.2-4.6-8.8-5.1c-4.2-0.6-8.4,1.4-12.1,3.3c-1.5,0.8-3.1,1.7-4.1,3c-0.8,1.3-1.2,2.6-1.4,4.1c-1.3,8.6-1.3,17.3-1.2,26 c0,6.3,0,12.6,1.4,18.7c0.7,3.2,1.7,6.3,2.2,9.5c0.4,2.8,0.5,5.7,0.4,8.5l0,11.9c0.1,2.2-0.1,4.4-0.5,6.5c-0.6,2.6-2,5-3,7.6 c-1,2.9-1.6,5.9-2,8.9l-1.8,12.4c-0.6,3.9-1,8.1,1.6,11.3c1.2,1.4,2.8,2.5,4,4c4.5,5.3,3.1,12.8,5,19.2c1.5,4.7,4.6,8.9,8.8,12 c3.3,2.5,7.4,4.4,11.6,3.7c5.6-0.9,9-6.2,10.6-11.1c1.5-4.9,2.1-10.3,5.4-14.5c2.7-3.4,6.9-5.6,10.8-8c3.8-2.4,7.5-5.6,8.4-9.7 c0.4-1.8,0.1-3.7,0.4-5.5c0.3-2.3,1.3-4.5,2.9-6.3c1.6-1.8,3.7-3.3,6.1-4.2c2.9-1,6.5-1.4,8.1-3.7c-4.2-2.1-7-6-8.5-10.1 c-1.5-4.1-1.8-8.4-2.1-12.7l-1-14.4c-0.4-6.4-0.6-12.8-3.8-18.5c-1.4-2.6-3.2-5-4.7-7.5c-2-3.6-3.6-7.3-5-11.1 c-2.3-5.9-4.6-11.8-6.7-17.7c-1-2.8-1.9-5.7-3.7-8.3C314.3,574.7,311.8,571.5,308.5,570.9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M344.4,664.2l-4.3,0.1l-0.9-5.7c-0.1-1.1-0.4-2.3-0.9-3.3c-0.7-1.1-1.5-2.2-2.5-3.2 c-4.2-5.3-3.9-12.3-4.9-18.7c-1.4-8.6-5.4-16.6-9.4-24.4l-8.3-16.4c-1.7-2.8-2.4-5.9-2.3-9.1c-0.1-2.5-0.9-11.8-1-14.3 c0-0.9,2.3-0.4,2.8-1.3c1-1.8,2.5,3.1,4.4,4.2c1.9,1.1,3,3.1,3.8,5c1.8,4.1,2.9,8.5,4.6,12.7c1.7,4.2,4,8.3,7.8,11.2 c1.7,1.3,3.7,2.4,5.3,3.8c5.2,4.5,5.7,11.7,5.9,18.2C344.5,626.6,345.4,664.2,344.4,664.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M282.8,564.1c4.2,1.5,6.4,5.5,7.6,9.3c1.2,3.8,1.6,7.9,3.9,11.4c5.2,8.1,18.5,10.4,22.2,19.1 c1.2,2.9,1.2,6,1.5,9c0.7,6.2,3,12.3,3.7,18.5c0.5,4.8,0.1,9.7-0.4,14.5l-4.6,49.2c-0.7,7.1-0.7,14.7,1.4,21.6 c-4.7,0.8-9.6-0.3-14-2c-4.4-1.8-8.4-4.2-12.6-6.3c-7.2-3.5-15.2-6-21.5-10.8c-1.1-0.8-2.1-1.8-2.9-2.8c-1.3-1.9-1.4-4.3-2-6.5 c-0.5-1.7-1.2-3.4-2.1-5.1c-2.3-5-4.3-10-6-15.2c-1.2-3.4-2.1-6.9-2.8-10.4c-0.5-2.8-0.8-5.6-1.1-8.5c-0.3-4.4-1.3-8.8-3-13 c-4-10-6.3-20.5-6.8-31.2c-0.1-1.5,0-3.1,0.3-4.6c0.6-1.9,1.8-3.5,2.8-5.2c1.9-3.2,3.1-6.8,4.9-10.1c4.1-7.4,11.4-13,19-17.7 C274.2,565.2,278.6,562.6,282.8,564.1z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M380,644.4c3.2-1.7,6.4-3.5,8.9-6c1.2-1.2,2.1-2.6,3.3-3.8c2.9-2.9,6.9-4.7,11.1-5.6 c4.2-0.9,8.6-1.1,12.9-1.1c2.9,0,5.9,0,8.6,0.9c2.7,0.9,5.2,2.9,5.7,5.4c0.6,3.1-1.6,6-4.3,8c-2.5,1.8-5.5,3.1-8.6,3.7 c-2.6,0.4-5.2,0.7-7.8,0.8c-15.4,1.4-29.1,8.9-42.6,15.6c-11.8,5.9-23.9,11.5-36.2,16.7c-0.5-3.3-0.7-6.6-0.6-9.9 c0.1-2.5,0.2-6.2,2.8-7.7c3.1-1.7,8.1-2.1,11.5-3.1c7.9-2.3,15.7-5.1,23.2-8.3C371.9,648.4,376,646.5,380,644.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M312.7,567.2c-15.1,0-27.4-11-27.4-24.5c0-13.5,12.3-24.5,27.4-24.5c15.1,0,27.4,11,27.4,24.5 C340.1,556.2,327.9,567.2,312.7,567.2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M275,591.8c2.4,2.5,3.7,5.8,5.3,8.8c3.4,6.2,8.7,11.5,11.4,18c2.8,6.8,2.7,14.9,8.2,20.3 c1,0.9,2.1,1.8,2.4,3.1c0.2,0.7,0,1.5,0.3,2.2c0.8,1.9,4.4,2,5,4c0.2,0.6,0.1,1.2,0.3,1.8c0.5,1.3,2.5,1.5,3.7,2.2 c2.7,1.6,2.1,5.3,4,7.6c1.5,1.8,4.3,2.4,6.9,2.1c2.5-0.3,4.8-1.4,7.1-2.4c0.8-0.4,1.7-0.6,2.6-0.7c1.1,0,2.1,0.3,3,0.9 c5.1,2.9,7.4,8.5,7.4,13.9c0,5.3-2.1,10.5-4.2,15.5c-0.3,0.8-0.8,1.6-1.4,2.3c-1.7,1.6-4.6,1.3-6.8,0.4c-2.2-0.9-4.3-2.3-6.7-2.6 c-4.2-0.7-8.4,1.9-12.7,1.7c-3.2-0.2-5.9-1.8-8.6-3.4c-4.2-2.5-8.4-5.1-11.5-8.7c-1.9-2.2-3.3-4.7-4.9-7c-2.1-2.9-4.4-5.6-6.9-8.2 L263,646.7c-3.8-3.7-6.4-8.2-7.6-13.1c-1.5-4.6-3-9.2-3.3-14c-0.2-3.9,0.4-7.8,1.1-11.7c0.7-3.8,1.5-7.7,3.4-11.2 C260.2,590.4,268.5,585.2,275,591.8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M265.8,520.3c-19.1,0-34.6-13.8-34.6-30.7c0-17,15.5-30.7,34.6-30.7c19.1,0,34.6,13.8,34.6,30.7 C300.4,506.6,284.9,520.3,265.8,520.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M235.9,515c4.5,2.9,9.7,4.8,15.1,5.5c5.5,0.7,11,0.3,16.3-1.3c5.2-1.6,10-4.2,13.8-7.8 c3.8-3.5,6.7-7.8,8.2-12.5c-0.6,4.2-2.2,8.3-4.6,11.9c-2.5,3.6-5.7,6.8-9.6,9.3c-3.9,2.5-8.3,4.2-13,5.1c-4.7,0.9-9.5,0.9-14.2,0 c-4.7-0.9-9.1-2.6-13-5.1c-3.9-2.5-7.2-5.6-9.6-9.3c-2.4-3.6-4-7.7-4.6-11.9c-0.6-4.2-0.2-8.5,1.2-12.6c-0.8,5.5,0.1,11,2.6,16.1 C226.9,507.4,230.9,511.8,235.9,515z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294,557.7c-14,0-25.4-10.1-25.4-22.5c0-12.4,11.4-22.5,25.4-22.5c14,0,25.4,10.1,25.4,22.5 C319.4,547.6,308.1,557.7,294,557.7z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M315.4,542.3c-12.4,0-22.5-7-22.5-15.6c0-8.6,10.1-15.6,22.5-15.6s22.5,7,22.5,15.6 C337.9,535.4,327.8,542.3,315.4,542.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M306.7,554.8c-1.5-1.1-1.2-3.6,0.6-5.6c1.8-2,4.6-2.8,6.1-1.7c1.5,1.1,1.2,3.6-0.6,5.6 C311,555.2,308.3,555.9,306.7,554.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.8,750.5c0,10.9,7.3,14.7,16.3,14.7c0.2,0,0.4,0,0.6,0c0.4,0,0.8,0,1.2,0c8.1-0.5,14.5-4.5,14.5-14.7 c0-10.5-15.1-23.8-16.3-24.7l0,0c0,0-0.1-0.1-0.1-0.1S334.8,739.6,334.8,750.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M351.7,763.6l-6-7.4l6,8.2l0,0.8c0.4,0,0.8,0,1.2,0l-0.6-10.9l0-0.1l0,0l-0.1-1l6-8.2l-6,7.5l0,0.2l-0.5-8.3 l5.1-8.5l-5.2,7.1l-0.5-17.1l0-0.1v0.1l0.1,13.5l-5.1-5.3l5.1,6.5l0.1,7.4l-4.8-7.1l4.8,8.2l0.1,4.1l-6.9-9.9l7,11.3L351.7,763.6z "
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_4_",
    x: 187.9,
    y: 86.3,
    transform: "matrix(0.8867 -0.4623 0.4623 0.8867 -90.4578 231.378)",
    width: 478,
    height: 428
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 605.6691,
    y1: 397.061,
    x2: 598.9615,
    y2: 409.9248,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M605.7,378.9c-2.8,1.5-6.7-0.2-8.5-3.7c-1.9-3.6-1-7.6,1.8-9.1c2.8-1.5,6.7,0.2,8.5,3.7 C609.3,373.4,608.5,377.5,605.7,378.9z"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M605.5,378.7c-2.7,1.4-6.4-0.2-8.1-3.6c-1.8-3.4-1-7.3,1.7-8.7c2.7-1.4,6.4,0.2,8.1,3.6 C609,373.3,608.2,377.2,605.5,378.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M565.9,235c-1.1,0.5-2.5-0.1-3.1-1.4c-0.7-1.3-0.4-2.8,0.7-3.4c1.1-0.5,2.5,0.1,3.1,1.4 C567.2,232.9,566.9,234.4,565.9,235z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M501.9,443.8c-1.1,0.5-2.5-0.1-3.1-1.4c-0.7-1.3-0.4-2.8,0.7-3.4s2.5,0.1,3.1,1.4 C503.3,441.7,503,443.2,501.9,443.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M588,413c-0.6,0.3-1.4,0-1.8-0.8c-0.4-0.7-0.2-1.6,0.4-1.9c0.6-0.3,1.4,0,1.8,0.8 C588.7,411.8,588.6,412.7,588,413z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M318.8,471.5c-0.6,0.3-1.4,0-1.8-0.8c-0.4-0.7-0.2-1.6,0.4-1.9c0.6-0.3,1.4,0,1.8,0.8 C319.6,470.4,319.4,471.2,318.8,471.5z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M317.5,320.5c-0.6,0.3-1.4,0-1.8-0.8c-0.4-0.7-0.2-1.6,0.4-1.9c0.6-0.3,1.4,0,1.8,0.8 C318.2,319.3,318.1,320.2,317.5,320.5z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M261.6,423.7c-0.6,0.3-1.4,0-1.8-0.8c-0.4-0.7-0.2-1.6,0.4-1.9c0.6-0.3,1.4,0,1.8,0.8 C262.4,422.5,262.2,423.4,261.6,423.7z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M491.7,174.6c-1.1,0.5-2.5-0.1-3.1-1.4c-0.7-1.3-0.4-2.8,0.7-3.4c1.1-0.5,2.5,0.1,3.1,1.4 C493.1,172.6,492.8,174.1,491.7,174.6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M626.7,305.8l1.7-0.9l-1.1-2.1l0.7-0.4l1.1,2.1l1.7-0.9l0.5,0.9l-1.7,0.9l1.1,2.1l-0.7,0.4l-1.1-2.1 l-1.7,0.9L626.7,305.8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M583.6,327.1l1.7-0.9l-1.1-2.1l0.7-0.4l1.1,2.1l1.7-0.9l0.4,0.9l-1.7,0.9l1.1,2.1l-0.7,0.4l-1.1-2.1 l-1.7,0.9L583.6,327.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M545.1,401.7l1.7-0.9l-1.1-2.1l0.7-0.4l1.1,2.1l1.7-0.9l0.4,0.9l-1.7,0.9l1.1,2.1l-0.7,0.4l-1.1-2.1 l-1.7,0.9L545.1,401.7z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M326.3,188.8l0.8-0.4l-0.5-1l0.3-0.2l0.5,1l0.8-0.4l0.2,0.4l-0.8,0.4l0.5,1l-0.3,0.2l-0.5-1l-0.8,0.4 L326.3,188.8z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M262.3,334.8l0.8-0.4l-0.5-1l0.3-0.2l0.5,1l0.8-0.4l0.2,0.4l-0.8,0.4l0.5,1l-0.3,0.2l-0.5-1l-0.8,0.4 L262.3,334.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M357.5,358.7l0.8-0.4l-0.5-1l0.3-0.2l0.5,1l0.8-0.4l0.2,0.4l-0.8,0.4l0.5,1l-0.3,0.2l-0.5-1l-0.8,0.4 L357.5,358.7z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M640.8,257.3l0.8-0.4l-0.5-1l0.3-0.2l0.5,1l0.8-0.4l0.2,0.4l-0.8,0.4l0.5,1l-0.3,0.2l-0.5-1l-0.8,0.4 L640.8,257.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M650.3,353l0.8-0.4l-0.5-1l0.3-0.2l0.5,1l0.8-0.4l0.2,0.4l-0.8,0.4l0.5,1l-0.3,0.2l-0.5-1l-0.8,0.4 L650.3,353z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M420.1,154.7l0.8-0.4l-0.5-1l0.3-0.2l0.5,1l0.8-0.4l0.2,0.4l-0.8,0.4l0.5,1l-0.3,0.2l-0.5-1l-0.8,0.4 L420.1,154.7z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M539.8,269.6l0.8-0.4l-0.5-1l0.3-0.2l0.5,1l0.8-0.4l0.2,0.4l-0.8,0.4l0.5,1l-0.3,0.2l-0.5-1l-0.8,0.4 L539.8,269.6z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M508.9,234.7l0.8-0.4l-0.5-1l0.3-0.2l0.5,1l0.8-0.4l0.2,0.4l-0.8,0.4l0.5,1l-0.3,0.2l-0.5-1l-0.8,0.4 L508.9,234.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 3568.5488,
    y1: -5714.0532,
    x2: 3439.5989,
    y2: -5466.7437,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M398.3,410c-2.4,1.2-5.6-0.2-7.1-3.1c-1.5-3-0.9-6.4,1.5-7.6c2.4-1.2,5.6,0.2,7.1,3.1 C401.4,405.4,400.7,408.8,398.3,410z"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M398.1,409.6c-2.2,1.1-5.1-0.1-6.6-2.9c-1.4-2.7-0.8-5.9,1.4-7c2.2-1.1,5.1,0.1,6.6,2.9 C401,405.3,400.3,408.5,398.1,409.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M406,450.8c-2.5,1.3-5.8-0.2-7.4-3.2c-1.6-3.1-0.9-6.6,1.6-7.9c2.5-1.3,5.8,0.2,7.4,3.2 C409.1,446,408.4,449.5,406,450.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 114501.1641,
    y1: -218259.5,
    x2: 7267.7637,
    y2: -12604.6914,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M364.3,273.5c-6.1-11.7-9.9-24.4-11-37c-0.5-5.9-0.2-9.9,0.3-12.5c0.2-1,0.6-1.9,1.3-2.5 c0.7-0.6,1.6-0.9,2.5-0.9c0.7,0,1.5,0.1,2.2,0.4c3.3,1.5,6.8,3.9,10.1,6.7c10.1,8.2,18.6,18.9,24.8,30.9l3.8,7.2l3.7-1.9 l-43.7-83.9c-9.2-17.6-15.1-36.6-16.9-55.2c-0.9-8.8-0.6-14.7,0-18.6c0.1-1,0.4-1.9,0.9-2.6c0.5-0.7,1.1-1.3,1.9-1.7 c0.8-0.4,1.6-0.6,2.5-0.6c0.9,0,1.8,0.3,2.7,0.7c4.7,2.3,9.9,6,14.8,10.2c14.7,12.3,27.3,28.5,36.7,46.5l43.3,83.1l3.2-1.7 l-3.9-7.6c-6.3-12-10.1-25.1-11.1-38c-0.3-4.3-0.3-8.6,0.3-12.1c0.2-1,0.6-1.9,1.4-2.5c0.7-0.6,1.6-0.9,2.6-0.8l-0.1,0.2 c0.6,0,1.2,0.2,1.8,0.4c2.4,1.1,5.9,3.2,10.4,7c9.7,8.1,18,18.5,24,30.2l65.4,125.4l-11.4,6l6.6,9.6l16.1,30.8l-9.4,4.9 l-16.1-30.8l-4.1-11l-11.3,5.9l-59.5-114.2l-3.2,1.7l59.3,113.7l-9.1,4.8l6.9,10.1l16.1,30.8l-9.4,4.9l-16.1-30.8l-4.3-11.5 l-12.3,6.4l7,10.1l16.1,30.8l-9.4,4.9l-16.1-30.8l-4.3-11.5l-7.3,3.8l-59.3-113.7l-3.7,1.9l59.6,114.4l-3,1.6l-0.1-0.2l-9.9,5.2 l6.6,9.6l16.1,30.8l-9.4,4.9l-16.1-30.8l-4.1-11l-10.1,5.3L364.3,273.5z"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M519.1,357.7l8.9-4.6l-8.6-12.6l-5.7,3L519.1,357.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M522.6,345.6l-6.6,3.4l-1.5-4l5.7-3L522.6,345.6z"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M443.2,397.3l8.9-4.6l-8.6-12.6l-5.7,3L443.2,397.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M446.7,385.2l-6.6,3.4l-1.5-4l5.7-3L446.7,385.2z"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M490.4,372.8l8.9-4.6l-8.6-12.6l-5.7,3L490.4,372.8z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M493.8,360.6l-6.6,3.4l-1.5-4l5.7-3L493.8,360.6z"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M472.3,382.2l8.9-4.6l-8.6-12.6l-5.7,3L472.3,382.2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M475.8,370l-6.6,3.4l-1.5-4l5.7-3L475.8,370z"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M391,266.3l63.3-33l1.6,3.2l-63.3,33L391,266.3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M355.2,221.5c0.1-0.6,0.3-1.2,0.6-1.7c0.3-0.5,0.7-0.9,1.2-1.1c0.5-0.3,1.1-0.4,1.6-0.4 c0.6,0,1.2,0.2,1.8,0.5c3.1,1.5,6.5,3.9,9.7,6.5c9.7,8.1,17.9,18.5,24,30.2l63.4,121.6l-28,14.6l-63.7-122.1 c-6-11.3-9.7-23.6-10.9-35.9C354.5,227.9,354.8,224,355.2,221.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M435.5,179.7c-0.6-0.3-1.2-0.4-1.8-0.5c-0.6,0-1.1,0.1-1.6,0.4c-0.5,0.3-0.9,0.6-1.2,1.1 c-0.3,0.5-0.5,1.1-0.6,1.7c-0.6,3.4-0.5,7.5-0.2,11.7c1.1,12.6,4.9,25.3,11,36.9l63.4,121.6l28-14.6L468.8,216 c-5.9-11.4-13.8-21.5-23.2-29.5C441.1,182.8,437.8,180.7,435.5,179.7z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M469.9,218.6l-6.6,3.5l5.3,10.2l6.6-3.5L469.9,218.6z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M448.8,229.7l-6.6,3.5l5.3,10.2l6.6-3.5L448.8,229.7z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M395.3,257.6l-6.6,3.5l5.3,10.2l6.6-3.5L395.3,257.6z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M374.1,268.6l-6.6,3.5l5.3,10.2l6.6-3.5L374.1,268.6z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M429.9,194c-0.3-4.2-0.4-8.3,0.2-11.7c0.1-1,0.6-1.8,1.3-2.4s1.5-0.9,2.5-0.8c-0.3,0.5-0.5,1-0.6,1.6 c-0.6,3.4-0.5,7.5-0.2,11.7c1.1,12.6,4.9,25.3,11,36.9l63.4,121.6l-3.2,1.7l-63.4-121.6C434.8,219.3,431,206.6,429.9,194z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M367.8,226.8c-3.2-2.7-6.6-5.1-9.7-6.6c-0.6-0.3-1.2-0.4-1.8-0.5c0.5-0.7,1.2-1.2,2-1.4 c0.8-0.2,1.7-0.1,2.6,0.4c3.1,1.5,6.5,3.9,9.7,6.5c9.7,8.1,17.9,18.5,24,30.2L458,377.1l-2.8,1.5L391.8,257 C385.7,245.3,377.5,234.9,367.8,226.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 523.5699,
    y1: 420.565,
    x2: 539.2217,
    y2: 390.5484,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FCCC63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F55F44"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M539.1,385.5l0.2-0.1c1.1-0.6,1.9-1.7,2.2-3.2s0-3-0.7-4.5L528,353.1l-8.9,4.6l12.8,24.6 c0.7,1.4,1.9,2.6,3.2,3.1C536.6,386.1,538,386.1,539.1,385.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 10326.041,
    y1: -18449.168,
    x2: 11334.001,
    y2: -20382.2676,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FCCC63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F55F44"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M510.3,400.5l0.2-0.1c1.1-0.6,1.9-1.7,2.2-3.2c0.3-1.4,0-3-0.7-4.5l-12.8-24.6l-8.9,4.6l12.8,24.6 c0.7,1.4,1.9,2.6,3.2,3.1C507.8,401.1,509.2,401.1,510.3,400.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 10307.96,
    y1: -18458.6621,
    x2: 11315.9102,
    y2: -20391.7598,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FCCC63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F55F44"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M492.3,409.9l0.3-0.1c1.1-0.6,1.9-1.7,2.2-3.2c0.3-1.4,0-3-0.7-4.5l-12.8-24.6l-8.9,4.6l12.8,24.6 c0.7,1.4,1.9,2.6,3.2,3.1C489.7,410.5,491.1,410.5,492.3,409.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 10279.2148,
    y1: -18473.5645,
    x2: 11287.165,
    y2: -20406.5645,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FCCC63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F55F44"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M463.2,425.1l0.2-0.1c0.6-0.3,1.1-0.7,1.4-1.3c0.4-0.5,0.7-1.2,0.8-1.9c0.1-0.7,0.1-1.5,0-2.2 c-0.1-0.8-0.4-1.5-0.7-2.2l-12.8-24.6l-8.9,4.6l12.8,24.6c0.7,1.4,1.9,2.6,3.2,3.1C460.6,425.7,462,425.7,463.2,425.1z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M342.1,107.1c0.1-0.9,0.4-1.8,0.8-2.5c0.5-0.7,1.1-1.3,1.8-1.7s1.5-0.5,2.4-0.5c0.9,0,1.7,0.3,2.5,0.7 c4.5,2.3,9.4,5.9,14.2,10c14.1,12.1,26.3,27.9,35.5,45.5l101.7,195.1l-40,20.8L359,178.7c-8.9-17.1-14.8-35.6-16.7-53.6 C341.4,116.5,341.6,110.8,342.1,107.1z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M351.3,129.9l12.6-6.6c2.3-1.2,5.3,0.2,6.8,3l0.9,1.7c1.5,2.8,0.8,6.1-1.4,7.3l-12.6,6.6 c-2.3,1.2-5.3-0.2-6.8-3l-0.9-1.7C348.4,134.3,349,131.1,351.3,129.9z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M363.1,186l39.5-20.6l1,1.9l-39.5,20.6L363.1,186z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 7166.9863,
    y1: -12602.166,
    x2: 6021.2871,
    y2: -10404.8672,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M331.4,293.3c0.1-2.2,0.7-4.3,1.6-6.2c1.1-2.1,2.6-3.8,4.5-5c1.9-1.2,4.1-1.8,6.4-1.8c2.3,0,4.7,0.6,6.9,1.8 c2.3,1.2,4.3,2.9,6.1,5c1.7,2.1,3.1,4.6,4,7.2c0.9,2.6,1.2,5.3,1.1,7.9c-0.2,2.6-0.9,4.9-2.1,7c-1.2,2-2.8,3.6-4.8,4.6 c-0.3,0.1-0.5,0.3-0.8,0.4c-2.4,1-5.1,1.2-7.9,0.6c-2.8-0.6-5.5-2.1-7.8-4.2s-4.2-4.8-5.5-7.8 C331.7,299.5,331.2,296.3,331.4,293.3L331.4,293.3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M334.5,303.9c2,3.8,5.1,6.9,8.7,8.6c3.6,1.7,7.3,1.9,10.5,0.5c0.3-0.1,0.5-0.2,0.8-0.4 c1.9-1,3.4-2.5,4.6-4.4c1.1-1.9,1.8-4.1,2-6.6c0.2-2.4-0.2-5-1-7.4c-0.8-2.5-2.1-4.8-3.8-6.8c-1.7-2-3.6-3.6-5.8-4.7 c-2.1-1.1-4.4-1.7-6.6-1.7c-2.2,0-4.2,0.6-6,1.7c-1.8,1.1-3.2,2.7-4.2,4.7c-0.9,1.7-1.4,3.7-1.5,5.9 C332,297,332.8,300.6,334.5,303.9z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344.6,286.4c0.8,0,1.6,0.1,2.4,0.2c0.5,0.1,1,0.3,1.5,0.6c0.2,0.2,0.5,0.4,0.6,0.7s0.2,0.6,0.2,0.9 c0,0.7-0.6,1-1,1.3c-0.5,0.4-1.1,0.6-1.7,0.6c-0.4,0-0.9-0.2-1.3-0.4l-1.7-0.6c-0.6-0.2-1.3-0.6-1.4-1.2c0-0.3,0-0.5,0.1-0.7 c0.1-0.2,0.2-0.4,0.4-0.5c0.8-0.7,1.8-1,2.9-0.8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M357.5,300.5c-0.4,0.2-0.8,0-1.1-0.5c-0.2-0.4-0.1-0.9,0.2-1.1c0.4-0.2,0.8,0,1.1,0.5 S357.8,300.3,357.5,300.5z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M343,304.4c-1.3,0.7-3-0.1-3.9-1.7c-0.8-1.6-0.5-3.5,0.8-4.1c1.3-0.7,3,0.1,3.9,1.7 C344.6,301.8,344.3,303.7,343,304.4z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.2,293.5c0.4,0.8,1,1.4,1.6,1.9s1.4,0.7,2.1,0.7c0.7,0,1.4-0.2,1.9-0.6c0.5-0.4,0.9-1.1,1.1-1.8 c0.2-0.7,0.2-1.6,0-2.4c-0.2-0.8-0.6-1.6-1.2-2.2c-0.6-0.6-1.2-1.1-2-1.4c-0.7-0.3-1.5-0.3-2.1-0.1 C332.8,289.4,332.3,291.4,332.2,293.5z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341.2,311.4c2,1.3,4.2,2.1,6.3,2.4c2.2,0.3,4.3,0,6.1-0.8c-0.1-0.2-0.2-0.4-0.3-0.6 c-0.7-1.3-1.7-2.5-2.8-3.3c-1.1-0.8-2.4-1.3-3.7-1.4c-1.3-0.1-2.5,0.2-3.5,0.9C342.5,309.2,341.7,310.2,341.2,311.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 7287.6528,
    y1: -12437.2959,
    x2: 6728.752,
    y2: -11365.3955,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M541.9,293.3c0.1-1.6,0.5-3,1.1-4.3c0.7-1.5,1.8-2.7,3.1-3.5c1.3-0.8,2.8-1.3,4.5-1.3c1.6,0,3.3,0.4,4.9,1.2 c1.6,0.8,3,2,4.3,3.5c1.2,1.5,2.2,3.2,2.8,5c0.6,1.8,0.9,3.7,0.7,5.5c-0.1,1.8-0.6,3.5-1.5,4.9c-0.8,1.4-2,2.5-3.4,3.2 c-0.2,0.1-0.4,0.2-0.6,0.3c-1.7,0.7-3.6,0.8-5.5,0.4c-1.9-0.5-3.8-1.5-5.4-2.9c-1.6-1.5-2.9-3.4-3.8-5.5 C542.2,297.6,541.8,295.4,541.9,293.3L541.9,293.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M544.1,300.7c1.4,2.7,3.6,4.8,6.1,6c2.5,1.2,5.1,1.3,7.4,0.4c0.2-0.1,0.4-0.2,0.5-0.3c1.3-0.7,2.4-1.7,3.2-3 c0.8-1.3,1.3-2.9,1.4-4.6c0.1-1.7-0.1-3.5-0.7-5.2c-0.6-1.7-1.5-3.3-2.6-4.7c-1.1-1.4-2.5-2.5-4-3.3c-1.5-0.8-3.1-1.2-4.6-1.2 c-1.5,0-3,0.4-4.2,1.2c-1.2,0.8-2.2,1.9-2.9,3.3c-0.6,1.2-1,2.6-1.1,4.1C542.3,295.9,542.9,298.4,544.1,300.7z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M551.1,288.5c0.6,0,1.1,0.1,1.7,0.2c0.4,0,0.7,0.2,1.1,0.4c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.2,0.6 c0,0.2-0.1,0.4-0.3,0.6c-0.1,0.2-0.3,0.3-0.5,0.4c-0.3,0.3-0.7,0.4-1.2,0.4c-0.3,0-0.6-0.1-0.9-0.2l-1.2-0.4 c-0.4-0.2-0.9-0.4-1-0.9c0-0.2,0-0.3,0.1-0.5c0.1-0.1,0.2-0.3,0.3-0.3c0.5-0.5,1.3-0.7,2-0.5"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M560.1,298.4c-0.2,0.1-0.6,0-0.7-0.3c-0.2-0.3-0.1-0.7,0.2-0.8c0.2-0.1,0.6,0,0.7,0.3 C560.4,297.9,560.4,298.2,560.1,298.4z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M550,301.1c-0.9,0.5-2.1-0.1-2.7-1.2c-0.6-1.1-0.3-2.4,0.6-2.9c0.9-0.5,2.1,0.1,2.7,1.2 C551.2,299.3,550.9,300.6,550,301.1z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M542.5,293.5c0.3,0.5,0.7,1,1.2,1.3c0.5,0.3,1,0.5,1.5,0.5s1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.8-1.3 c0.1-0.5,0.1-1.1,0-1.7c-0.2-0.6-0.4-1.1-0.8-1.6c-0.4-0.4-0.9-0.8-1.4-0.9c-0.5-0.2-1-0.2-1.5,0 C542.9,290.6,542.6,292,542.5,293.5z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M548.8,306c1.4,0.9,2.9,1.5,4.4,1.7c1.5,0.2,3,0,4.3-0.6c-0.1-0.1-0.2-0.3-0.2-0.5c-0.5-0.9-1.2-1.7-2-2.3 c-0.8-0.6-1.7-0.9-2.6-1c-0.9-0.1-1.7,0.1-2.4,0.6C549.6,304.4,549.1,305.1,548.8,306L548.8,306z"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M287.8,386.4c-0.4,0.2-0.9,0-1.1-0.5c-0.2-0.5-0.1-1,0.2-1.2c0.4-0.2,0.9,0,1.1,0.5 C288.3,385.6,288.2,386.2,287.8,386.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.7811,
    y1: 405.5541,
    x2: 510.4329,
    y2: 375.5376,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FCCC63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F55F44"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M510.3,400.5l0.2-0.1c1.1-0.6,1.9-1.7,2.2-3.2s0-3-0.7-4.5l-12.8-24.6l-8.9,4.6l12.8,24.6 c0.7,1.4,1.9,2.6,3.2,3.1C507.8,401.1,509.2,401.1,510.3,400.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 476.7473,
    y1: 396.1509,
    x2: 492.399,
    y2: 366.1344,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FCCC63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F55F44"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M492.3,409.9l0.2-0.1c1.1-0.6,1.9-1.7,2.2-3.2s0-3-0.7-4.5l-12.8-24.6l-8.9,4.6l12.8,24.6 c0.7,1.4,1.9,2.6,3.2,3.1C489.7,410.5,491.1,410.5,492.3,409.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.6432,
    y1: 380.9751,
    x2: 463.295,
    y2: 350.9586,
    gradientTransform: "matrix(1 0 0 -1 -2.467910e-05 776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FCCC63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F55F44"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M463.2,425.1l0.2-0.1c1.1-0.6,1.9-1.7,2.2-3.2s0-3-0.7-4.5l-12.8-24.6l-8.9,4.6l12.8,24.6 c0.7,1.4,1.9,2.6,3.2,3.1C460.6,425.7,462,425.7,463.2,425.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlRocket);
export default __webpack_public_path__ + "static/media/girlRocket.166119e86cafeba4fcde116b9bcf8239.svg";
export { ForwardRef as ReactComponent };